import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// A gentle, one-time invitation to step to The Mirror on first arrival.
export default function MirrorInvite() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("mos_mirror_invited")) {
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("mos_mirror_invited", "1");
    setOpen(false);
  };

  const enter = () => {
    localStorage.setItem("mos_mirror_invited", "1");
    setOpen(false);
    navigate("/the-mirror");
  };

  if (!open) return null;

  return (
    <div
      data-testid="mirror-invite"
      className="fixed inset-0 z-[120] grid place-items-center px-6"
      style={{ background: "rgba(13,10,8,0.92)", backdropFilter: "blur(8px)" }}
    >
      <div className="relative max-w-md w-full text-center fade-up">
        <div
          aria-hidden
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -z-10 rounded-full slow-pulse"
          style={{
            height: "22rem", width: "22rem",
            background: "radial-gradient(circle, rgba(212,175,55,0.22), transparent 68%)",
            filter: "blur(18px)",
          }}
        />
        <p className="text-[#D4AF37] tracking-[0.35em] uppercase text-xs mb-5">Before you enter</p>
        <h2 className="serif text-4xl text-[#F7F1E6] font-light leading-tight">
          There is a <span className="italic-serif text-[#D4AF37]">mirror</span> here.
        </h2>
        <p className="mt-5 text-[#B4A897] leading-relaxed">
          It shows only what you are willing to see, and there is no judgment in it. If you are ready to
          seek a deeper truth within yourself, you can look into anything and everything in your life.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3">
          <button data-testid="mirror-invite-enter" onClick={enter}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#D4AF37] text-[#17100C] px-8 py-3.5 font-medium hover:bg-[#e6c860] transition-colors duration-300 gold-glow">
            Step to the mirror
          </button>
          <button data-testid="mirror-invite-skip" onClick={dismiss}
            className="text-sm text-[#B4A897] hover:text-[#F7F1E6] transition-colors duration-300">
            Not today
          </button>
        </div>
      </div>
    </div>
  );
}
